var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var CompanyIndividualContactsVue_1;
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { PersonsClient, NotificationsClient, GetPersonListPaginatedQuery, PaginatedEnumerableOfPersonModel, PersonModel, CreatePersonCommand, UpdatePersonCommand, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { HttpHelper } from "@/app/utils/http-helper";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const personsClient = new PersonsClient(window.apiUrl);
const notificationsClient = new NotificationsClient(window.apiUrl);
let CompanyIndividualContactsVue = CompanyIndividualContactsVue_1 = class CompanyIndividualContactsVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.editingPerson = false;
        this.searchAttempted = false;
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "FirstName",
            direction: SortDirection.Ascending
        }));
        // models
        this.person = new PersonModel();
        this.query = new GetPersonListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false,
            companyId: this.companyId,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfPersonModel();
    }
    created() {
        this.search();
    }
    ;
    // get
    search() {
        if (!this.canSearch)
            return;
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        personsClient
            .getListPaginated(this.query)
            .then(response => {
            this.data = new PaginatedEnumerableOfPersonModel();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        this.search();
    }
    ;
    // set
    add() {
        this.person = new PersonModel();
        this.resetForm();
        this.person.companyId = this.query.companyId || 0;
        this.editingPerson = true;
    }
    ;
    edit(person) {
        this.person = new PersonModel(person);
        this.editingPerson = true;
        this.setValues({
            firstName: this.person.firstName,
            lastName: this.person.lastName,
            email: this.person.emailAddress || undefined,
            mobilePhone: this.person.mobilePhone || undefined,
            workPhone: this.person.workPhone || undefined,
        });
    }
    ;
    save(person) {
        if (this.working)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            let promise = () => {
                return !person.personId
                    ? personsClient.add(new CreatePersonCommand({ requestModel: person }))
                    : personsClient.update(person.personId, new UpdatePersonCommand({ requestModel: person }));
            };
            promise().then(response => {
                Notifier.onOk();
                person.personId = response;
                this.$emit(CompanyIndividualContactsVue_1.contactsUpdatedEvent);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.search();
            });
        }, () => {
            Notifier.onError("Please check that you have correctly entered all contacts fields.");
        });
        handleSubmitAction();
    }
    ;
    archive(person) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this contact?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            personsClient
                .delete(person.personId)
                .then(() => {
                person.whenDeleted = new Date();
                var personInTheList = this.data.records.find(item => item.personId == person.personId);
                if (personInTheList) {
                    personInTheList.whenDeleted = new Date();
                }
                Notifier.onOk();
                this.$emit(CompanyIndividualContactsVue_1.contactsUpdatedEvent);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore(person) {
        if (this.working)
            return;
        this.working = true;
        personsClient
            .restore(person.personId)
            .then(() => {
            person.whenDeleted = undefined;
            var personInTheList = this.data.records.find(item => item.personId == person.personId);
            if (personInTheList) {
                personInTheList.whenDeleted = undefined;
            }
            Notifier.onOk();
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.$emit(CompanyIndividualContactsVue_1.contactsUpdatedEvent);
        });
    }
    ;
    cancel() {
        this.resetForm();
        this.person = new PersonModel();
        this.editingPerson = false;
    }
    ;
    testEmail() {
        if (this.person.emailAddress) {
            notificationsClient.testEmailNotification(this.person.emailAddress)
                .then((response) => {
                if (response)
                    Notifier.onOk("Email message was sent successfuly. Check if it was delivered to the contact!");
                else
                    Notifier.onError("Email message was NOT sent successfuly. Check the email address and try again or contact the Support Team!");
            });
        }
    }
    testSMS() {
        if (this.person.mobilePhone) {
            notificationsClient.testSMSNotification(this.companyId, this.person.mobilePhone)
                .then((response) => {
                if (response)
                    Notifier.onOk("SMS message was sent successfuly. Check if it was delivered to the contact!");
                else
                    Notifier.onError("SMS message was NOT sent successfuly. Check the AWS fields the in Company details page!");
            });
        }
    }
    // computed
    get canSearch() {
        return this.companyId ? true : false;
    }
    ;
    get validMobilePhone() {
        if (this.person.mobilePhone)
            return this.person.mobilePhone.trim().startsWith('+') && this.person.mobilePhone.length > 8;
        return false;
    }
    get validEmail() {
        var _a;
        if (this.person.emailAddress) {
            if ((_a = this.errors) === null || _a === void 0 ? void 0 : _a.email)
                return false;
            return true;
        }
        return false;
    }
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
};
CompanyIndividualContactsVue.contactsUpdatedEvent = "contactsUpdated";
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanyIndividualContactsVue.prototype, "companyId", void 0);
__decorate([
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanyIndividualContactsVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanyIndividualContactsVue.prototype, "onSortChanged", null);
CompanyIndividualContactsVue = CompanyIndividualContactsVue_1 = __decorate([
    Component({
        name: "CompanyIndividualContactsVue",
        emits: ["contactsUpdated"],
        setup() {
            let phoneRegExp = new RegExp("^(?=.*[0-9])[- +()0-9]+$");
            const { errors, handleSubmit, defineInputBinds, setValues, resetForm } = useForm({
                validationSchema: yup.object({
                    firstName: yup.string().trim().required(),
                    lastName: yup.string().trim().required(),
                    email: yup.string().email(),
                    mobilePhone: yup.string().phoneNumber(),
                    workPhone: yup.string().phoneNumber(),
                }),
            });
            const firstNameVal = defineInputBinds('firstName');
            const lastNameVal = defineInputBinds('lastName');
            const emailVal = defineInputBinds('email');
            const mobilePhoneVal = defineInputBinds('mobilePhone');
            const workPhoneVal = defineInputBinds('workPhone');
            return {
                errors,
                handleSubmit,
                setValues,
                resetForm,
                firstNameVal,
                lastNameVal,
                emailVal,
                mobilePhoneVal,
                workPhoneVal
            };
        }
    })
], CompanyIndividualContactsVue);
export default CompanyIndividualContactsVue;
